import React from 'react';
import { Icon } from './Icon.js';
export const IconInfraredThermometer = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M16 11L14.5 15H10.5", stroke: "currentColor", strokeWidth: "2", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M11 19L9.66268 17.6667L11.5 11H21V3H5.99999L3.99999 9L5.49999 11L3 20L3.99999 21H10.5L11 19Z", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M13 7H16", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", "data-color": "color-2", fill: "none" })));
};
//# sourceMappingURL=IconInfraredThermometer.js.map